export interface LogoIconProps {
  class?: string;
}

export function LightHorizontalWithLogoImg(props: LogoIconProps) {
  return (
    <img className={props.class} src="/svg/logos/zephyr-light-logo.svg" alt="Zephyr logo" width={128} height={48} />
  );
}
